<template>
  <a :id="id" :class="_class" :data-button="linkText" :href="link">{{
    linkText
  }}</a>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatSkipLink",
  inject: { resolveTxt: { from: "resolveTxt", default: false } },
  props: {
    id: {
      type: [String, Number]
    },
    linkText: {
      type: String,
      description: "Skip link text"
    },
    link: {
      type: String,
      description: "The link where to navigate to"
    },
    top: {
      type: Boolean,
      default: true,
      description:
        "If the skip link is to be displayed fixed on top of the page"
    },
    center: {
      type: Boolean,
      default: true,
      description:
        "If the skip link is to be centered horizontally on the screen."
    }
  },
  computed: {
    _class: function () {
      return {
        "cat-skip-link": true,
        "skip-link": true,
        top: this.top,
        center: this.center
      };
    }
  }
});
</script>
